// this is an autogenerated file from DesignSystem/PatientInformation/Content/Relations/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__DesignSystem_PatientInformation_Content_Relations($person_id: uuid!) {
  vaxiom_relationships(
    where: {
      to_person_record: { _id: { _eq: $person_id } }
      role: { _eq: "RESPONSIBLE" }
    }
  ) {
    id
    type
    role
    from_person_record {
      id
      first_name
      middle_name
      last_name
      profile_pic_url
      emails: contact_method_associations(
        where: { contact_method: { dtype: { _eq: "email" } } }
        limit: 1
      ) {
        id
        email {
          id
          address
        }
      }
      phones: contact_method_associations(
        where: { contact_method: { dtype: { _eq: "phone" } } }
        limit: 1
      ) {
        id
        phone {
          id
          number
        }
      }
      patient {
        id
        appointments(
          where: {
            tx: {
              deleted: { _eq: false }
              tx_card: { deleted: { _eq: false } }
            }
          }
          limit: 1
          order_by: { sys_created: desc }
        ) {
          id
          tx {
            id
            tx_status_name {
              id
              name
            }
            tx_card {
              id
              name
            }
          }
        }
      }
    }
  }
}

`